"use strict";

import { Check } from "lucide-react";
import { motion } from "framer-motion";

/**
 * Why Choose Us content model
 * Easily extensible and CMS-friendly
 */
const whyChooseUs = [
  {
    title: "Certified Expert Guidance",
    description:
      "Work with experienced and certified consultants who provide accurate advice tailored to your visa, travel, or migration needs from start to finish.",
  },
  {
    title: "Fast & Reliable Processing",
    description:
      "We streamline documentation and application processes to ensure timely submissions, faster approvals, and minimal delays.",
  },
  {
    title: "Affordable Travel Solutions",
    description:
      "Enjoy competitive flight ticket pricing for students, families, and travellers without compromising comfort or convenience.",
  },
  {
    title: "Transparent & Trusted Services",
    description:
      "No hidden charges, no misleading promises. We provide clear communication, honest timelines, and full visibility throughout your journey.",
  },
];

export function WhyChooseUsSection() {
  return (
    <section
      id="why-choose-us"
      className="py-24 bg-gray-100"
      aria-labelledby="why-choose-us-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2
            id="why-choose-us-heading"
            className="font-poppins text-4xl md:text-5xl font-bold text-[#004E89] tracking-tight leading-tight mb-4"
          >
            Why Choose Us
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600 text-base md:text-lg">
            We combine expertise, efficiency, and transparency to deliver
            stress-free travel and migration experiences.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.45, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 h-full"
            >
              <div className="flex flex-col h-full">
                {/* Icon */}
                <div className="mb-5">
                  <div className="w-10 h-10 rounded-full bg-[#800020] flex items-center justify-center">
                    <Check className="w-5 h-5 text-white" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="font-poppins text-lg font-semibold text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="font-jakarta text-gray-600 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
